import { apiMutator } from '../../../../frontend/src/lib/api-orval-mutator'
/**
 * Auto-generated from the Django backend OpenAPI schema.
 * To modify these types, update the Django serializers or views, then run:
 *   hogli build:openapi
 * Questions or issues? #team-devex on Slack
 *
 * PostHog API - generated
 * OpenAPI spec version: 1.0.0
 */
import type {
    AffectedCohortRequestApi,
    AffectedCohortResponseApi,
    ApplyPromptSuggestionRequestApi,
    BackfillEstimateResponseApi,
    BackfillWindowApi,
    BulkObserveRequestApi,
    BulkObserveResponseApi,
    CreateTaskFromObservationResponseApi,
    CurrentPromptSuggestionApi,
    DraftScannerRequestApi,
    DraftScannerResponseApi,
    EstimateRequestApi,
    EstimateResponseApi,
    EvaluatePromptSuggestionRequestApi,
    InlineScanRequestApi,
    InlineScanResponseApi,
    ObservationStatsApi,
    ObserveAlreadyScannedApi,
    ObserveRequestApi,
    ObserveResponseApi,
    PaginatedReplayObservationListApi,
    PaginatedReplayScannerBackfillListApi,
    PaginatedReplayScannerListApi,
    PaginatedReplayScannerPromptSuggestionListApi,
    PaginatedVisionActionListApi,
    PaginatedVisionActionRunListListApi,
    PatchedReplayScannerApi,
    PatchedVisionActionApi,
    ReplayObservationApi,
    ReplayObservationLabelApi,
    ReplayScannerApi,
    ReplayScannerBackfillApi,
    ReplayScannerPromptSuggestionApi,
    RetryResponseApi,
    RunActionResponseApi,
    ScannerCreatorsResponseApi,
    ScannerImpactApi,
    ScannerScoutCreateApi,
    ScannerScoutCreateResponseApi,
    ScannerSelfDrivingStatsApi,
    ScannerStatsResponseApi,
    ScoutReportApi,
    SuggestTagsRequestApi,
    SuggestTagsResponseApi,
    VisionActionApi,
    VisionActionRunApi,
    VisionActionsListParams,
    VisionActionsRunsListParams,
    VisionObservationsListParams,
    VisionObservationsRetrieveParams,
    VisionQuotaApi,
    VisionScannersBackfillsListParams,
    VisionScannersImpactRetrieveParams,
    VisionScannersListParams,
    VisionScannersObservationsListParams,
    VisionScannersObservationsRetrieveParams,
    VisionScannersObservationsStatsRetrieveParams,
    VisionScannersPromptSuggestionsListParams,
} from './api.schemas'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
    [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
    ? {
          [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P]
      }
    : DistributeReadOnlyOverUnions<T>

export const getVisionActionsListUrl = (projectId: string, params?: VisionActionsListParams) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/actions/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/actions/`
}

/**
 * CRUD for Replay Vision actions — scheduled "and then…" automations over a scanner's observations.
 */
export const visionActionsList = async (
    projectId: string,
    params?: VisionActionsListParams,
    options?: RequestInit
): Promise<PaginatedVisionActionListApi> => {
    return apiMutator<PaginatedVisionActionListApi>(getVisionActionsListUrl(projectId, params), {
        ...options,
        method: 'GET',
    })
}

export const getVisionActionsCreateUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/actions/`
}

/**
 * CRUD for Replay Vision actions — scheduled "and then…" automations over a scanner's observations.
 */
export const visionActionsCreate = async (
    projectId: string,
    visionActionApi: NonReadonly<VisionActionApi>,
    options?: RequestInit
): Promise<VisionActionApi> => {
    return apiMutator<VisionActionApi>(getVisionActionsCreateUrl(projectId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(visionActionApi),
    })
}

export const getVisionActionsRetrieveUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/actions/${id}/`
}

/**
 * CRUD for Replay Vision actions — scheduled "and then…" automations over a scanner's observations.
 */
export const visionActionsRetrieve = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<VisionActionApi> => {
    return apiMutator<VisionActionApi>(getVisionActionsRetrieveUrl(projectId, id), {
        ...options,
        method: 'GET',
    })
}

export const getVisionActionsPartialUpdateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/actions/${id}/`
}

/**
 * CRUD for Replay Vision actions — scheduled "and then…" automations over a scanner's observations.
 */
export const visionActionsPartialUpdate = async (
    projectId: string,
    id: string,
    patchedVisionActionApi?: NonReadonly<PatchedVisionActionApi>,
    options?: RequestInit
): Promise<VisionActionApi> => {
    return apiMutator<VisionActionApi>(getVisionActionsPartialUpdateUrl(projectId, id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedVisionActionApi),
    })
}

export const getVisionActionsDestroyUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/actions/${id}/`
}

/**
 * CRUD for Replay Vision actions — scheduled "and then…" automations over a scanner's observations.
 */
export const visionActionsDestroy = async (projectId: string, id: string, options?: RequestInit): Promise<void> => {
    return apiMutator<void>(getVisionActionsDestroyUrl(projectId, id), {
        ...options,
        method: 'DELETE',
    })
}

export const getVisionActionsRunCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/actions/${id}/run/`
}

/**
 * Run this summary now, without waiting for its schedule — synthesizes a group summary over the
 * observations since the last summary (or the last 24h). The recurring schedule is untouched: the
 * engine advances next_run_at only at scheduled claim time, never in the run itself.
 */
export const visionActionsRunCreate = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<RunActionResponseApi> => {
    return apiMutator<RunActionResponseApi>(getVisionActionsRunCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
    })
}

export const getVisionActionsRunsListUrl = (
    projectId: string,
    visionActionId: string,
    params?: VisionActionsRunsListParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/actions/${visionActionId}/runs/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/actions/${visionActionId}/runs/`
}

/**
 * Read-only run history for a single vision action (nested under /vision/actions/{action_id}/runs/).
 */
export const visionActionsRunsList = async (
    projectId: string,
    visionActionId: string,
    params?: VisionActionsRunsListParams,
    options?: RequestInit
): Promise<PaginatedVisionActionRunListListApi> => {
    return apiMutator<PaginatedVisionActionRunListListApi>(
        getVisionActionsRunsListUrl(projectId, visionActionId, params),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionActionsRunsRetrieveUrl = (projectId: string, visionActionId: string, id: string) => {
    return `/api/projects/${projectId}/vision/actions/${visionActionId}/runs/${id}/`
}

/**
 * Read-only run history for a single vision action (nested under /vision/actions/{action_id}/runs/).
 */
export const visionActionsRunsRetrieve = async (
    projectId: string,
    visionActionId: string,
    id: string,
    options?: RequestInit
): Promise<VisionActionRunApi> => {
    return apiMutator<VisionActionRunApi>(getVisionActionsRunsRetrieveUrl(projectId, visionActionId, id), {
        ...options,
        method: 'GET',
    })
}

export const getVisionObservationsListUrl = (projectId: string, params: VisionObservationsListParams) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/observations/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/observations/`
}

/**
 * Read-only access to a session's observations across every scanner the caller can read, for the replay-page dock.
 */
export const visionObservationsList = async (
    projectId: string,
    params: VisionObservationsListParams,
    options?: RequestInit
): Promise<PaginatedReplayObservationListApi> => {
    return apiMutator<PaginatedReplayObservationListApi>(getVisionObservationsListUrl(projectId, params), {
        ...options,
        method: 'GET',
    })
}

export const getVisionObservationsRetrieveUrl = (
    projectId: string,
    id: string,
    params?: VisionObservationsRetrieveParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/observations/${id}/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/observations/${id}/`
}

/**
 * Retrieve one observation. Any list filters passed along (status, tags, order_by, …) scope the `previous_observation_id`/`next_observation_id` navigation to the matching, identically-ordered set — so prev/next from a filtered table stays within that filtered list.
 */
export const visionObservationsRetrieve = async (
    projectId: string,
    id: string,
    params?: VisionObservationsRetrieveParams,
    options?: RequestInit
): Promise<ReplayObservationApi> => {
    return apiMutator<ReplayObservationApi>(getVisionObservationsRetrieveUrl(projectId, id, params), {
        ...options,
        method: 'GET',
    })
}

export const getVisionObservationsCreateTaskCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/observations/${id}/create_task/`
}

/**
 * Create a PostHog Task from this observation's finding so it can be triaged and fixed. Title and description are derived from the scanner and its result. Record-only: this does not start the coding agent. Idempotent per observation: once a task exists, repeat calls return its id with a 200 instead of creating a duplicate.
 */
export const visionObservationsCreateTaskCreate = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<CreateTaskFromObservationResponseApi> => {
    return apiMutator<CreateTaskFromObservationResponseApi>(getVisionObservationsCreateTaskCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
    })
}

export const getVisionObservationsLabelCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/observations/${id}/label/`
}

/**
 * Set or update the observation's shared label: whether the scanner scored the session correctly, plus optional feedback on what it got wrong. One label per observation, shared across the team; these labels feed prompt improvement. Requires editor access to the scanner.
 */
export const visionObservationsLabelCreate = async (
    projectId: string,
    id: string,
    replayObservationLabelApi: ReplayObservationLabelApi,
    options?: RequestInit
): Promise<ReplayObservationLabelApi> => {
    return apiMutator<ReplayObservationLabelApi>(getVisionObservationsLabelCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(replayObservationLabelApi),
    })
}

export const getVisionObservationsLabelDestroyUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/observations/${id}/label/`
}

/**
 * Remove the observation's shared label. Requires editor access to the scanner.
 */
export const visionObservationsLabelDestroy = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<void> => {
    return apiMutator<void>(getVisionObservationsLabelDestroyUrl(projectId, id), {
        ...options,
        method: 'DELETE',
    })
}

export const getVisionObservationsRetryCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/observations/${id}/retry/`
}

/**
 * Delete a failed or ineligible observation and re-run its scanner on the same recording. Returns 202 with the workflow handle.
 */
export const visionObservationsRetryCreate = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<RetryResponseApi> => {
    return apiMutator<RetryResponseApi>(getVisionObservationsRetryCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
    })
}

export const getEnvironmentVisionQuotaRetrieveUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/quota/`
}

export const environmentVisionQuotaRetrieve = async (
    projectId: string,
    options?: RequestInit
): Promise<VisionQuotaApi> => {
    return apiMutator<VisionQuotaApi>(getEnvironmentVisionQuotaRetrieveUrl(projectId), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersListUrl = (projectId: string, params?: VisionScannersListParams) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/`
}

/**
 * CRUD for Replay Vision scanners.
 */
export const visionScannersList = async (
    projectId: string,
    params?: VisionScannersListParams,
    options?: RequestInit
): Promise<PaginatedReplayScannerListApi> => {
    return apiMutator<PaginatedReplayScannerListApi>(getVisionScannersListUrl(projectId, params), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersCreateUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/`
}

/**
 * CRUD for Replay Vision scanners.
 */
export const visionScannersCreate = async (
    projectId: string,
    replayScannerApi: NonReadonly<ReplayScannerApi>,
    options?: RequestInit
): Promise<ReplayScannerApi> => {
    return apiMutator<ReplayScannerApi>(getVisionScannersCreateUrl(projectId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(replayScannerApi),
    })
}

export const getVisionScannersRetrieveUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/`
}

/**
 * CRUD for Replay Vision scanners.
 */
export const visionScannersRetrieve = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<ReplayScannerApi> => {
    return apiMutator<ReplayScannerApi>(getVisionScannersRetrieveUrl(projectId, id), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersPartialUpdateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/`
}

/**
 * CRUD for Replay Vision scanners.
 */
export const visionScannersPartialUpdate = async (
    projectId: string,
    id: string,
    patchedReplayScannerApi?: NonReadonly<PatchedReplayScannerApi>,
    options?: RequestInit
): Promise<ReplayScannerApi> => {
    return apiMutator<ReplayScannerApi>(getVisionScannersPartialUpdateUrl(projectId, id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedReplayScannerApi),
    })
}

export const getVisionScannersDestroyUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/`
}

/**
 * CRUD for Replay Vision scanners.
 */
export const visionScannersDestroy = async (projectId: string, id: string, options?: RequestInit): Promise<void> => {
    return apiMutator<void>(getVisionScannersDestroyUrl(projectId, id), {
        ...options,
        method: 'DELETE',
    })
}

export const getVisionScannersAffectedCohortCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/affected_cohort/`
}

/**
 * Save the users this scanner matched as a static cohort, for surveys, funnels, and retention analysis.
 */
export const visionScannersAffectedCohortCreate = async (
    projectId: string,
    id: string,
    affectedCohortRequestApi?: AffectedCohortRequestApi,
    options?: RequestInit
): Promise<AffectedCohortResponseApi> => {
    return apiMutator<AffectedCohortResponseApi>(getVisionScannersAffectedCohortCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(affectedCohortRequestApi),
    })
}

export const getVisionScannersBulkObserveCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/bulk_observe/`
}

/**
 * Apply this scanner to many sessions on demand. Starts as many as fit under the in-flight
 * caps and monthly credit quota, reporting the rest as skipped rather than failing the batch.
 */
export const visionScannersBulkObserveCreate = async (
    projectId: string,
    id: string,
    bulkObserveRequestApi: BulkObserveRequestApi,
    options?: RequestInit
): Promise<BulkObserveResponseApi> => {
    return apiMutator<BulkObserveResponseApi>(getVisionScannersBulkObserveCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bulkObserveRequestApi),
    })
}

export const getVisionScannersImpactRetrieveUrl = (
    projectId: string,
    id: string,
    params?: VisionScannersImpactRetrieveParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/${id}/impact/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/${id}/impact/`
}

/**
 * Affected sessions and users for this scanner over the trailing window.
 */
export const visionScannersImpactRetrieve = async (
    projectId: string,
    id: string,
    params?: VisionScannersImpactRetrieveParams,
    options?: RequestInit
): Promise<ScannerImpactApi> => {
    return apiMutator<ScannerImpactApi>(getVisionScannersImpactRetrieveUrl(projectId, id, params), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersObserveCreateUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/observe/`
}

/**
 * Apply this scanner to one specific session, on demand. Returns 202 with the workflow handle.
 */
export const visionScannersObserveCreate = async (
    projectId: string,
    id: string,
    observeRequestApi: ObserveRequestApi,
    options?: RequestInit
): Promise<ObserveAlreadyScannedApi | ObserveResponseApi> => {
    return apiMutator<ObserveAlreadyScannedApi | ObserveResponseApi>(getVisionScannersObserveCreateUrl(projectId, id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(observeRequestApi),
    })
}

export const getVisionScannersSelfDrivingStatsRetrieveUrl = (projectId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${id}/self_driving_stats/`
}

/**
 * What self-driving did with this scanner's signals: reports contributed to and PRs opened.
 */
export const visionScannersSelfDrivingStatsRetrieve = async (
    projectId: string,
    id: string,
    options?: RequestInit
): Promise<ScannerSelfDrivingStatsApi> => {
    return apiMutator<ScannerSelfDrivingStatsApi>(getVisionScannersSelfDrivingStatsRetrieveUrl(projectId, id), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersBackfillsListUrl = (
    projectId: string,
    scannerId: string,
    params?: VisionScannersBackfillsListParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/`
}

/**
 * Historical backfills of a scanner over a closed time window (nested under a scanner).
 */
export const visionScannersBackfillsList = async (
    projectId: string,
    scannerId: string,
    params?: VisionScannersBackfillsListParams,
    options?: RequestInit
): Promise<PaginatedReplayScannerBackfillListApi> => {
    return apiMutator<PaginatedReplayScannerBackfillListApi>(
        getVisionScannersBackfillsListUrl(projectId, scannerId, params),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionScannersBackfillsCreateUrl = (projectId: string, scannerId: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/`
}

/**
 * Create a backfill: freeze the scanner config, enumerate the exact candidate set, start the tick schedule.
 *
 * The enumeration reruns here rather than trusting the client-confirmed estimate: the count is
 * billing-relevant, so the authoritative value is computed server-side at creation time. New
 * settled sessions between estimate and confirm can nudge total_count slightly.
 */
export const visionScannersBackfillsCreate = async (
    projectId: string,
    scannerId: string,
    backfillWindowApi: BackfillWindowApi,
    options?: RequestInit
): Promise<ReplayScannerBackfillApi> => {
    return apiMutator<ReplayScannerBackfillApi>(getVisionScannersBackfillsCreateUrl(projectId, scannerId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(backfillWindowApi),
    })
}

export const getVisionScannersBackfillsRetrieveUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/${id}/`
}

/**
 * Historical backfills of a scanner over a closed time window (nested under a scanner).
 */
export const visionScannersBackfillsRetrieve = async (
    projectId: string,
    scannerId: string,
    id: string,
    options?: RequestInit
): Promise<ReplayScannerBackfillApi> => {
    return apiMutator<ReplayScannerBackfillApi>(getVisionScannersBackfillsRetrieveUrl(projectId, scannerId, id), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersBackfillsCancelCreateUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/${id}/cancel/`
}

/**
 * Stop an active backfill; already-dispatched observations finish, nothing new dispatches.
 */
export const visionScannersBackfillsCancelCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    replayScannerBackfillApi?: NonReadonly<ReplayScannerBackfillApi>,
    options?: RequestInit
): Promise<ReplayScannerBackfillApi> => {
    return apiMutator<ReplayScannerBackfillApi>(getVisionScannersBackfillsCancelCreateUrl(projectId, scannerId, id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(replayScannerBackfillApi),
    })
}

export const getVisionScannersBackfillsResumeCreateUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/${id}/resume/`
}

/**
 * Restart a backfill that paused when the monthly quota ran out.
 */
export const visionScannersBackfillsResumeCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    replayScannerBackfillApi?: NonReadonly<ReplayScannerBackfillApi>,
    options?: RequestInit
): Promise<ReplayScannerBackfillApi> => {
    return apiMutator<ReplayScannerBackfillApi>(getVisionScannersBackfillsResumeCreateUrl(projectId, scannerId, id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(replayScannerBackfillApi),
    })
}

export const getVisionScannersBackfillsEstimateCreateUrl = (projectId: string, scannerId: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/backfills/estimate/`
}

/**
 * Exactly enumerate what a backfill over the given window would dispatch and cost.
 */
export const visionScannersBackfillsEstimateCreate = async (
    projectId: string,
    scannerId: string,
    backfillWindowApi: BackfillWindowApi,
    options?: RequestInit
): Promise<BackfillEstimateResponseApi> => {
    return apiMutator<BackfillEstimateResponseApi>(getVisionScannersBackfillsEstimateCreateUrl(projectId, scannerId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(backfillWindowApi),
    })
}

export const getVisionScannersObservationsListUrl = (
    projectId: string,
    scannerId: string,
    params?: VisionScannersObservationsListParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/`
}

/**
 * Read-only access to observations produced by a scanner.
 */
export const visionScannersObservationsList = async (
    projectId: string,
    scannerId: string,
    params?: VisionScannersObservationsListParams,
    options?: RequestInit
): Promise<PaginatedReplayObservationListApi> => {
    return apiMutator<PaginatedReplayObservationListApi>(
        getVisionScannersObservationsListUrl(projectId, scannerId, params),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionScannersObservationsRetrieveUrl = (
    projectId: string,
    scannerId: string,
    id: string,
    params?: VisionScannersObservationsRetrieveParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/${id}/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/${id}/`
}

/**
 * Retrieve one observation. Any list filters passed along (status, tags, order_by, …) scope the `previous_observation_id`/`next_observation_id` navigation to the matching, identically-ordered set — so prev/next from a filtered table stays within that filtered list.
 */
export const visionScannersObservationsRetrieve = async (
    projectId: string,
    scannerId: string,
    id: string,
    params?: VisionScannersObservationsRetrieveParams,
    options?: RequestInit
): Promise<ReplayObservationApi> => {
    return apiMutator<ReplayObservationApi>(
        getVisionScannersObservationsRetrieveUrl(projectId, scannerId, id, params),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionScannersObservationsCreateTaskCreateUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/${id}/create_task/`
}

/**
 * Create a PostHog Task from this observation's finding so it can be triaged and fixed. Title and description are derived from the scanner and its result. Record-only: this does not start the coding agent. Idempotent per observation: once a task exists, repeat calls return its id with a 200 instead of creating a duplicate.
 */
export const visionScannersObservationsCreateTaskCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    options?: RequestInit
): Promise<CreateTaskFromObservationResponseApi> => {
    return apiMutator<CreateTaskFromObservationResponseApi>(
        getVisionScannersObservationsCreateTaskCreateUrl(projectId, scannerId, id),
        {
            ...options,
            method: 'POST',
        }
    )
}

export const getVisionScannersObservationsLabelCreateUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/${id}/label/`
}

/**
 * Set or update the observation's shared label: whether the scanner scored the session correctly, plus optional feedback on what it got wrong. One label per observation, shared across the team; these labels feed prompt improvement. Requires editor access to the scanner.
 */
export const visionScannersObservationsLabelCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    replayObservationLabelApi: ReplayObservationLabelApi,
    options?: RequestInit
): Promise<ReplayObservationLabelApi> => {
    return apiMutator<ReplayObservationLabelApi>(
        getVisionScannersObservationsLabelCreateUrl(projectId, scannerId, id),
        {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(replayObservationLabelApi),
        }
    )
}

export const getVisionScannersObservationsLabelDestroyUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/${id}/label/`
}

/**
 * Remove the observation's shared label. Requires editor access to the scanner.
 */
export const visionScannersObservationsLabelDestroy = async (
    projectId: string,
    scannerId: string,
    id: string,
    options?: RequestInit
): Promise<void> => {
    return apiMutator<void>(getVisionScannersObservationsLabelDestroyUrl(projectId, scannerId, id), {
        ...options,
        method: 'DELETE',
    })
}

export const getVisionScannersObservationsRetryCreateUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/${id}/retry/`
}

/**
 * Delete a failed or ineligible observation and re-run its scanner on the same recording. Returns 202 with the workflow handle.
 */
export const visionScannersObservationsRetryCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    options?: RequestInit
): Promise<RetryResponseApi> => {
    return apiMutator<RetryResponseApi>(getVisionScannersObservationsRetryCreateUrl(projectId, scannerId, id), {
        ...options,
        method: 'POST',
    })
}

export const getVisionScannersObservationsStatsRetrieveUrl = (
    projectId: string,
    scannerId: string,
    params?: VisionScannersObservationsStatsRetrieveParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/stats/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/${scannerId}/observations/stats/`
}

/**
 * Aggregate counts and per-scanner-type distributions over the filtered observation set. Same filters as the list endpoint apply.
 */
export const visionScannersObservationsStatsRetrieve = async (
    projectId: string,
    scannerId: string,
    params?: VisionScannersObservationsStatsRetrieveParams,
    options?: RequestInit
): Promise<ObservationStatsApi> => {
    return apiMutator<ObservationStatsApi>(
        getVisionScannersObservationsStatsRetrieveUrl(projectId, scannerId, params),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionScannersPromptSuggestionsListUrl = (
    projectId: string,
    scannerId: string,
    params?: VisionScannersPromptSuggestionsListParams
) => {
    const normalizedParams = new URLSearchParams()

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value))
        }
    })

    const stringifiedParams = normalizedParams.toString()

    return stringifiedParams.length > 0
        ? `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/?${stringifiedParams}`
        : `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/`
}

/**
 * AI prompt-rewrite suggestions for a scanner, generated from the team's thumbs up/down ratings.
 */
export const visionScannersPromptSuggestionsList = async (
    projectId: string,
    scannerId: string,
    params?: VisionScannersPromptSuggestionsListParams,
    options?: RequestInit
): Promise<PaginatedReplayScannerPromptSuggestionListApi> => {
    return apiMutator<PaginatedReplayScannerPromptSuggestionListApi>(
        getVisionScannersPromptSuggestionsListUrl(projectId, scannerId, params),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionScannersPromptSuggestionsApplyCreateUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/${id}/apply/`
}

/**
 * Apply this suggestion: write a config to the scanner (the prompt plus any type-specific config such as classifier tags or the monitor allow_inconclusive flag), bumping the scanner version, and mark the suggestion applied. Pass `config` to apply an edited subset of the recommendation; omit it to apply the full suggested config. Only the current pending suggestion can be applied. Requires session recording edit access.
 */
export const visionScannersPromptSuggestionsApplyCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    applyPromptSuggestionRequestApi?: ApplyPromptSuggestionRequestApi,
    options?: RequestInit
): Promise<ReplayScannerPromptSuggestionApi> => {
    return apiMutator<ReplayScannerPromptSuggestionApi>(
        getVisionScannersPromptSuggestionsApplyCreateUrl(projectId, scannerId, id),
        {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(applyPromptSuggestionRequestApi),
        }
    )
}

export const getVisionScannersPromptSuggestionsDismissCreateUrl = (
    projectId: string,
    scannerId: string,
    id: string
) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/${id}/dismiss/`
}

/**
 * Dismiss this suggestion without applying it. Only the current pending suggestion can be dismissed. Requires editor access to the scanner.
 */
export const visionScannersPromptSuggestionsDismissCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    options?: RequestInit
): Promise<ReplayScannerPromptSuggestionApi> => {
    return apiMutator<ReplayScannerPromptSuggestionApi>(
        getVisionScannersPromptSuggestionsDismissCreateUrl(projectId, scannerId, id),
        {
            ...options,
            method: 'POST',
        }
    )
}

export const getVisionScannersPromptSuggestionsEvaluateCreateUrl = (
    projectId: string,
    scannerId: string,
    id: string
) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/${id}/evaluate/`
}

/**
 * Test this suggestion before applying it: re-run the scanner with the suggested prompt against already-rated sessions in the background and compare each fresh output with the stored one. Results land on the suggestion's `evaluation` field. Poll `current` while status is running. `session_limit` controls how many rated sessions are re-run (thumbs-down prioritized, up to `evaluation_session_cap`). Each successful re-run charges credits like a normal observation of the same model. The request is refused with 402 when the planned credits exceed what is left for the current billing period, either the org's limit or this scanner's own. Monitor and classifier scanners get a kept/fixed/regressed classification, while scorer and summarizer scanners show the raw before and after output. Requires session recording edit access.
 */
export const visionScannersPromptSuggestionsEvaluateCreate = async (
    projectId: string,
    scannerId: string,
    id: string,
    evaluatePromptSuggestionRequestApi?: EvaluatePromptSuggestionRequestApi,
    options?: RequestInit
): Promise<ReplayScannerPromptSuggestionApi> => {
    return apiMutator<ReplayScannerPromptSuggestionApi>(
        getVisionScannersPromptSuggestionsEvaluateCreateUrl(projectId, scannerId, id),
        {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(evaluatePromptSuggestionRequestApi),
        }
    )
}

export const getVisionScannersPromptSuggestionsCurrentRetrieveUrl = (projectId: string, scannerId: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/current/`
}

/**
 * The scanner's newest prompt suggestion plus whether it is stale (the ratings changed since it was generated) and how many rated observations are available.
 */
export const visionScannersPromptSuggestionsCurrentRetrieve = async (
    projectId: string,
    scannerId: string,
    options?: RequestInit
): Promise<CurrentPromptSuggestionApi> => {
    return apiMutator<CurrentPromptSuggestionApi>(
        getVisionScannersPromptSuggestionsCurrentRetrieveUrl(projectId, scannerId),
        {
            ...options,
            method: 'GET',
        }
    )
}

export const getVisionScannersPromptSuggestionsGenerateCreateUrl = (projectId: string, scannerId: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/prompt_suggestions/generate/`
}

/**
 * Generate a fresh prompt suggestion from the team's current ratings. The previous pending suggestion becomes history (superseded). Requires at least one rated observation and editor access to the scanner.
 */
export const visionScannersPromptSuggestionsGenerateCreate = async (
    projectId: string,
    scannerId: string,
    options?: RequestInit
): Promise<ReplayScannerPromptSuggestionApi> => {
    return apiMutator<ReplayScannerPromptSuggestionApi>(
        getVisionScannersPromptSuggestionsGenerateCreateUrl(projectId, scannerId),
        {
            ...options,
            method: 'POST',
        }
    )
}

export const getVisionScannersScoutReportsListUrl = (projectId: string, scannerId: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/scout_reports/`
}

/**
 * Reports filed by this scanner's scouts, newest first.
 */
export const visionScannersScoutReportsList = async (
    projectId: string,
    scannerId: string,
    options?: RequestInit
): Promise<ScoutReportApi[]> => {
    return apiMutator<ScoutReportApi[]>(getVisionScannersScoutReportsListUrl(projectId, scannerId), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersScoutReportsRetrieveUrl = (projectId: string, scannerId: string, id: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/scout_reports/${id}/`
}

/**
 * One report filed by this scanner's scouts.
 */
export const visionScannersScoutReportsRetrieve = async (
    projectId: string,
    scannerId: string,
    id: string,
    options?: RequestInit
): Promise<ScoutReportApi> => {
    return apiMutator<ScoutReportApi>(getVisionScannersScoutReportsRetrieveUrl(projectId, scannerId, id), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersScoutsCreateUrl = (projectId: string, scannerId: string) => {
    return `/api/projects/${projectId}/vision/scanners/${scannerId}/scouts/`
}

/**
 * Create a scout that watches this scanner, recorded as belonging to it.
 */
export const visionScannersScoutsCreate = async (
    projectId: string,
    scannerId: string,
    scannerScoutCreateApi: ScannerScoutCreateApi,
    options?: RequestInit
): Promise<ScannerScoutCreateResponseApi> => {
    return apiMutator<ScannerScoutCreateResponseApi>(getVisionScannersScoutsCreateUrl(projectId, scannerId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(scannerScoutCreateApi),
    })
}

export const getVisionScannersCreatorsRetrieveUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/creators/`
}

/**
 * Distinct creators across the team's scanners — feeds the `Created by` filter dropdown.
 */
export const visionScannersCreatorsRetrieve = async (
    projectId: string,
    options?: RequestInit
): Promise<ScannerCreatorsResponseApi> => {
    return apiMutator<ScannerCreatorsResponseApi>(getVisionScannersCreatorsRetrieveUrl(projectId), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersDraftCreateUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/draft/`
}

/**
 * Draft a full scanner configuration from a natural-language goal, for the goal-based creation flow.
 */
export const visionScannersDraftCreate = async (
    projectId: string,
    draftScannerRequestApi: DraftScannerRequestApi,
    options?: RequestInit
): Promise<DraftScannerResponseApi> => {
    return apiMutator<DraftScannerResponseApi>(getVisionScannersDraftCreateUrl(projectId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(draftScannerRequestApi),
    })
}

export const getVisionScannersEstimateCreateUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/estimate/`
}

/**
 * Estimate the observation volume a proposed scanner would generate, for the pre-save cost preview.
 */
export const visionScannersEstimateCreate = async (
    projectId: string,
    estimateRequestApi?: EstimateRequestApi,
    options?: RequestInit
): Promise<EstimateResponseApi> => {
    return apiMutator<EstimateResponseApi>(getVisionScannersEstimateCreateUrl(projectId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(estimateRequestApi),
    })
}

export const getVisionScannersInlineScanCreateUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/inline_scan/`
}

/**
 * Scan named sessions against a prompt without saving a scanner first, for one-off questions.
 *
 * The config resolves to a scanner minted on first use, so asking the same question twice reuses
 * the observations it already has, while a different question about the same session gets its own.
 */
export const visionScannersInlineScanCreate = async (
    projectId: string,
    inlineScanRequestApi: InlineScanRequestApi,
    options?: RequestInit
): Promise<InlineScanResponseApi> => {
    return apiMutator<InlineScanResponseApi>(getVisionScannersInlineScanCreateUrl(projectId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(inlineScanRequestApi),
    })
}

export const getVisionScannersStatsRetrieveUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/stats/`
}

/**
 * Team-wide scanner counts — independent of list filters, so the overview stays stable.
 */
export const visionScannersStatsRetrieve = async (
    projectId: string,
    options?: RequestInit
): Promise<ScannerStatsResponseApi> => {
    return apiMutator<ScannerStatsResponseApi>(getVisionScannersStatsRetrieveUrl(projectId), {
        ...options,
        method: 'GET',
    })
}

export const getVisionScannersSuggestTagsCreateUrl = (projectId: string) => {
    return `/api/projects/${projectId}/vision/scanners/suggest_tags/`
}

/**
 * Suggest classifier tags grounded in the scanner's own observations and the org's product data.
 */
export const visionScannersSuggestTagsCreate = async (
    projectId: string,
    suggestTagsRequestApi: SuggestTagsRequestApi,
    options?: RequestInit
): Promise<SuggestTagsResponseApi> => {
    return apiMutator<SuggestTagsResponseApi>(getVisionScannersSuggestTagsCreateUrl(projectId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(suggestTagsRequestApi),
    })
}
